import axios from 'axios';
import { has } from 'lodash';
import VueInstance from '../main.js';

const JOULE_BACKEND_URL = process.env.VUE_APP_JOULE_BACKEND;
let objectToCreate = {
  baseURL: JOULE_BACKEND_URL
};
const instance = axios.create(objectToCreate);

// Add a request interceptor
instance.interceptors.request.use(
  config => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (has(userData, 'accessToken')) {
      config.headers.common.Authorization = userData.accessToken;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    switch (error.response.status) {
      case 401:
        window.location.replace('/');
        localStorage.removeItem('userData');
        VueInstance.$store.commit('LOGOUT');
        break;
      case 403:
        window.location.replace('/portal/perfil');
        break;
      default:
        return Promise.reject(error);
    }
  }
);

export const http = instance;
